import deliveryOptionType from './../delivery-options-types';
export default function RailsService(
    railsApiService,
) {
    'ngInject';

    Object.assign(this, {
        processRailBeforeInsertToBasket,
        getStaticData,
        getTicketRestrictions,
        getFareTypes,
    });

    function getTicketRestrictions(ticketType, tripId) {
        return railsApiService.getTicketRestrictions(ticketType, tripId);
    }

    function getFareTypes(fareTypeIds) {
        return railsApiService.getFareTypes(fareTypeIds);
    }

    function processRailBeforeInsertToBasket(params, searchId, isRoundtrip) { // eslint-disable-line
        const segments = [];
        const groupIds = [];
        const totalPassengers = [
            params.Travelers.Adult.value,
            params.Travelers.Child.value,
        ].reduce((acc, value) => acc + parseInt(value, 10), 0);

        let totalPrice = 0.0;

        if (params.selectedOutwardTicketDetails) {
            const railGroup = params.selectedOutwardTicketDetails.RailJourneyDetail;
            const segmentObject = {
                fromStationName: camelize(railGroup.OriginName),
                toStationName: camelize(railGroup.DestinationName),
                fromStationCode: railGroup.OriginCode,
                toStationCode: railGroup.DestCode,
                departureDate: railGroup.DepartureDate,
                arrivalDate: railGroup.ArrivalDate,
                diffDays: moment(railGroup.ArrivalDate, 'YYYY-MM-DD').diff(moment(railGroup.DepartureDate, 'YYYY-MM-DD'), 'days'),
                duration: railGroup.JourneyDuration,
                canBeBooked: true,
                rails: params.selectedOutwardTicketDetails.RailJourneyDetail.RailLegs,
            };

            groupIds.push(railGroup.Id);
            segments.push(segmentObject);
            totalPrice = params.selectedOutwardTicketDetails.Total;
        }

        if (params.selectedReturnTicketDetails) {
            const railGroup = params.selectedReturnTicketDetails.RailJourneyDetail;
            const segmentObject = {
                fromStationName: camelize(railGroup.OriginName),
                toStationName: camelize(railGroup.DestinationName),
                fromStationCode: railGroup.OriginCode,
                toStationCode: railGroup.DestCode,
                departureDate: railGroup.DepartureDate,
                arrivalDate: railGroup.ArrivalDate,
                diffDays: moment(railGroup.ArrivalDate, 'YYYY-MM-DD').diff(moment(railGroup.DepartureDate, 'YYYY-MM-DD'), 'days'),
                duration: railGroup.JourneyDuration,
                canBeBooked: true,
                rails: params.selectedReturnTicketDetails.RailJourneyDetail.RailLegs,
            };

            groupIds.push(railGroup.Id);
            segments.push(segmentObject);

            if (!params.hasReturnTicketCommonPrice) {
                totalPrice += params.selectedReturnTicketDetails.Total;
            }
        }
        const varFastOutwardSearchId = [
            params.selectedOutwardTicketDetails.RailJourneyDetail.Id,
            params.selectedOutwardTicketDetails.Id,
            groupIds.join(''),
        ].join('');

        const varFastReturnSearchId = [
            params.selectedReturnTicketDetails.RailJourneyDetail && params.selectedReturnTicketDetails.RailJourneyDetail.Id || '',
            params.selectedReturnTicketDetails && params.selectedReturnTicketDetails.Id || '',
            groupIds.join(''),
        ].join('');

        const header = 'Rail Search';
        let addOn = null;
        const outSeatPreference = [];
        const returnSeatPreference = [];
        const deliveryDetails = {
            CorpKiosk: null,
            Country: null,
            CustomerEmail: null,
            CustomerName: null,
            IsOfficeSpecific: false,
            Line1: null,
            Line2: null,
            Line3: null,
            Line4: null,
            Line5: null,
            Message: null,
            Name: null,
            OfficeDrop: null,
            PDFLink: null,
            PINEmail: null,
            PostCode: null,
            Station: null,
            TravellingSeparately: null,
            TravellingTogether: null,
        };

        if (params.TravelCards) {
            addOn = {
                Type: params.TravelCards.CardType,
                Zones: params.TravelCards.Zones,
                Date: params.selectedOutwardTicketDetails.RailJourneyDetail.DepartureDate,
                TotalCost: (parseFloat(params.TravelCards.AdultFare) * parseInt(params.adultCount, 10)),
                AdultsFare: params.TravelCards.AdultFare,
                NumOfAdults: params.adultCount,
            };
        }

        if (isCorporateOrStandartKioskDeliveryOption(params)) {
            deliveryDetails.PINEmail = params.TicketCollectionEmail;
        }

        if (params.TicketCollectionStation) {
            deliveryDetails.Station = params.TicketCollectionStation;
            deliveryDetails.PINEmail = params.TicketCollectionEmail;
        }
        if (['Post', 'NextDay', 'SameDayOfficeDrop'].includes(params.TicketDeliveryOption.TypeName)) {
            if (params.TicketByPostAddressLines) {
                deliveryDetails.Name = params.TicketByPostName;
                deliveryDetails.Line1 = params.TicketByPostAddressLines.Line1;
                deliveryDetails.Line2 = params.TicketByPostAddressLines.Line2;
                deliveryDetails.Line3 = params.TicketByPostAddressLines.Line3;
                deliveryDetails.Line4 = params.TicketByPostAddressLines.Line4;
                deliveryDetails.Line5 = params.TicketByPostAddressLines.Line5;
                deliveryDetails.PostCode = params.TicketByPostCode;
                deliveryDetails.Country = params.TicketByPostCountry;
            }
        }
        if (params.TicketDeliveryOption.TypeName === 'Mobile') {
            if (params.TicketByMobileName) {
                deliveryDetails.CustomerName = params.TicketByMobileName;
                deliveryDetails.CustomerEmail = params.TicketCollectionEmail;
                deliveryDetails.TravellingTogether = [];
                const objPassanger = {
                    PassengerName: params.TicketByMobileName,
                    RailcardCode: '',
                    PassengerType: 'Adult',
                };
                deliveryDetails.TravellingTogether.push(objPassanger);
                angular.forEach(params.selectedOutwardTicketDetails.AppliedRailCard, (railCard) => {
                    deliveryDetails.TravellingTogether[0].RailcardCode = railCard.CardCode;
                });
            }
        }
        if (params.TicketDeliveryOption.TypeName === 'CorporateKiosk') {
            if (params.TicketCollectionCorpKiosk) {
                deliveryDetails.CorpKiosk = params.TicketCollectionCorpKiosk;
            }
        }
        if (params.TicketDeliveryOption.TypeName === 'SameDayOfficeDrop') {
            if (params.TicketByCorpPrinter && params.TicketByCorpPrinter) {
                deliveryDetails.OfficeDrop = params.TicketByCorpPrinter;
            }
        }
        if (params.TicketDeliveryOption && params.TicketDeliveryOption) {
            totalPrice += params.TicketDeliveryOption.Cost;
        }

        if (params.TravelCards && params.TravelCards) {
            totalPrice += (params.TravelCards.AdultFare * params.Travelers.Adult.value);
        }

        if (params.TicketDeliveryOption.TypeName === 'PrintYourOwn') {
            deliveryDetails.CustomerEmail = params.TicketCollectionEmail;

            if (params.PassengerNames) {
                deliveryDetails.CustomerName = params.PassengerNames[1];
                angular.forEach(params.PassengerNames, function(passenger) {
                    const objPassanger = {
                        PassengerName: passenger,
                        RailcardCode: '',
                        PassengerType: 'Adult',
                    };
                    if (params.PassengerNames.length > 2) {
                        if (!deliveryDetails.TravellingSeparately) {
                            deliveryDetails.TravellingSeparately = [];
                        }
                        deliveryDetails.TravellingSeparately.push(objPassanger);
                    } else {
                        deliveryDetails.TravellingTogether = [];
                        deliveryDetails.TravellingTogether.push(objPassanger);
                    }
                });
                let PassengerIndex = 0;
                angular.forEach(params.selectedOutwardTicketDetails.AppliedRailCard, function(railCard) {
                    for (let i = 0; i < railCard.Num; i++) {
                        if (params.PassengerNames.length > 2) {
                            deliveryDetails.TravellingSeparately[PassengerIndex].RailcardCode = railCard.CardCode;
                        } else {
                            deliveryDetails.TravellingTogether[PassengerIndex].RailcardCode = railCard.CardCode;
                        }
                        PassengerIndex++;
                    }
                });
            }
        }

        if (params.outwardSeatReservationYesOrNo || params.selectedOutwardTicketDetails.ReservationRequired) {
            if (params.RRPreferenceOptionsDirection) {
                outSeatPreference.push({Code: params.RRPreferenceOptionsDirection});
            }
            if (params.RRPreferenceOptionsPosition) {
                outSeatPreference.push({Code: params.RRPreferenceOptionsPosition});
            }
            if (params.RRPreferenceOptionsEnvironment) {
                outSeatPreference.push({Code: params.RRPreferenceOptionsEnvironment});
            }
            if (params.isTableSeatSelected) {
                outSeatPreference.push({Code: 'TABL'});
            }
            if (params.isSeatSelectedNearLuggageRack) {
                outSeatPreference.push({Code: 'LUGG'});
            }
            if (params.isPowerSocketSeatSelected) {
                outSeatPreference.push({Code: 'POWE'});
            }
            if (params.isSeatSelectedNearToilet) {
                outSeatPreference.push({Code: 'NRWC'});
            }
        }

        if (params.returnSeatReservationYesOrNo || params.selectedReturnTicketDetails.ReservationRequired) {
            if (params.RRPreferenceOptionsDirection) {
                returnSeatPreference.push({Code: params.RRPreferenceOptionsDirection});
            }
            if (params.RRPreferenceOptionsPosition) {
                returnSeatPreference.push({Code: params.RRPreferenceOptionsPosition});
            }
            if (params.RRPreferenceOptionsEnvironment) {
                returnSeatPreference.push({Code: params.RRPreferenceOptionsEnvironment});
            }
            if (params.isTableSeatSelected) {
                returnSeatPreference.push({Code: 'TABL'});
            }
            if (params.isSeatSelectedNearLuggageRack) {
                returnSeatPreference.push({Code: 'LUGG'});
            }
            if (params.isPowerSocketSeatSelected) {
                returnSeatPreference.push({Code: 'POWE'});
            }
            if (params.isSeatSelectedNearToilet) {
                returnSeatPreference.push({Code: 'NRWC'});
            }
        }

        const outOfPolicyStatusOutward = params.selectedOutwardTicketDetails.OutOfPolicyStatus;
        let outOfPolicyStatusReturn = 0;
        if (params.selectedReturnTicketDetails) {
            outOfPolicyStatusReturn = params.selectedReturnTicketDetails.OutOfPolicyStatus;
        }

        return {
            header,
            searchId,
            outwardJourneyId: params.selectedOutwardTicketDetails.RailJourneyDetail.Id,
            outwardJourneyTicketId: params.selectedOutwardTicketDetails.Id,
            ReturnJourneyId: params.selectedReturnTicketDetails.RailJourneyDetail && params.selectedReturnTicketDetails.RailJourneyDetail.Id || '',
            ReturnJourneyTicketId: params.selectedReturnTicketDetails && params.selectedReturnTicketDetails.Id || '',
            groupIds,
            fastOutwardSearchId: varFastOutwardSearchId,
            fastReturnSearchId: varFastReturnSearchId,
            isRoundtrip,
            fastSearchId: varFastOutwardSearchId + varFastReturnSearchId,
            company: params.selectedOutwardTicketDetails.RailJourneyDetail.RailLegs[0].ServiceProviderName,
            price: totalPrice,
            seats: totalPassengers,
            infants: 0,
            segments,
            ReturnOrSingle: params.ReturnOrSingleJourney,
            AddOns: addOn,
            TicketDeliveryOptionType: params.TicketDeliveryOption.TypeName,
            DeliveryDetails: deliveryDetails,
            OutSeatPreference: outSeatPreference,
            ReturnSeatPreference: returnSeatPreference,
            TicketDeliveryOptionFee: params.TicketDeliveryOption.Cost,
            OutOfPolicyStatus: Math.max(outOfPolicyStatusOutward, outOfPolicyStatusReturn),
        };
    }

    function camelize(str) {
        return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    }

    function getStaticData() {
        return railsApiService.getStaticData()
            .then(({data}) => data);
    }

    function isCorporateOrStandartKioskDeliveryOption(params) {
        const deliveryTypes = [
            deliveryOptionType.KIOSK.typeName,
            deliveryOptionType.CORPORATEKIOSK.typeName,
        ];
        return params
            && params.TicketDeliveryOption
            && deliveryTypes.includes(params.TicketDeliveryOption.TypeName);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/services/rails-service.js